// extracted by mini-css-extract-plugin
export var contrastLow = "_23-1";
export var externalLink = "_23-2";
export var externalLinkIcon = "_23-3";
export var link = "_23-0";
export var linkLabel = "_23-4";